import React, {Component} from 'react';
import SlateSelect from "../../Shared/SlateSelect";
import './FormSlateViewTimeZone.css';

export default class FormSlateViewTimeZone extends Component {
  render() {
    var t = this.props.t;
    var handleChangeTimeZone = this.props.handleChangeTimeZone;
    var currentTimeZone = this.props.currentTimeZone;
    var timeZones = this.props.timeZones;
    var hideWarning = this.props.hideWarning;

    return (
      <div className="timezone-selector">
        {!hideWarning && (
          <p className="timezone-selector-hint">
            {t('export:timeZoneWarning')}
          </p>
        )}

        <div className="timezone-selector-dropdown">
          <SlateSelect
            defaultValue={currentTimeZone}
            options={timeZones}
            onChange={handleChangeTimeZone}
            placeholder="Select timezone..."
            searchable
            dropUp
          />
        </div>
      </div>
    );
  }
}
